import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-285" data-mp="1wbmnhgp93kki">
    <App data-id="element-286" data-mp="1wd7c6povw9ag" />
  </BrowserRouter>, document.getElementById('root'));